import styled from '@emotion/styled';

export const NonPlayableIcon = styled.div({
    display: 'block',
    overflow: 'visible',
    height: '60px',
    width: '60px',
    marginTop: '-30px',
    marginLeft: '-30px',
    borderRadius: '50%',
    backgroundColor: '#279BE4',
    ':before': {
        display: 'block',
        content: 'no-open-quote',
        position: 'absolute',
        left: '-5px',
        marginTop: '5px',
        height: '50px',
        width: '10px',
        borderRadius: '10px',
        backgroundColor: '#fff',
        transform: 'rotate(45deg)',
    },
    ':after': {
        display: 'block',
        content: 'no-close-quote',
        position: 'absolute',
        left: '-5px',
        marginTop: '5px',
        height: '50px',
        width: '10px',
        borderRadius: '10px',
        backgroundColor: '#fff',
        transform: 'rotate(-45deg)',
    },
    ':hover': {
        backgroundColor: '#0274BD',
    }
});
